import { useTranslation } from 'react-i18next'
import { Block, CRIcon, CRRender, Inline } from '../../crRender'
import "../inputsGlobals.css"
import './style.css'
import useFileUpload from './hooks/useFileUpload'
import { UploadFileHints } from '@/components/popups/filesUploadPopup/components/UploadFile'
import ItemPreviewer from './ItemPreviewer/ItemPreviewer'

const FileUpload = ({ accept, value, setValue, label, isRequired = false, multiple = false, maxfilesize = 100, maxfiles = 10 }) => {
    const { t } = useTranslation()
    const { isDragging, dropZoneRef, inputRef,
        getFileIcon, formatFileSize, handleDragEnter,
        handleDragLeave, handleDrop, handleInputChange,
        handleRemove, stopDefaultEvent, getFileFormat, errors } = useFileUpload(value, setValue, multiple, maxfilesize, maxfiles,accept)


const supportedTypes = accept?.map((type) => t(UploadFileHints[type])).join(", ")


    return (
        <div className={`file-upload-container`}>
            <CRRender isRender={!!label}>
                <label className="file-upload-label">
                    {t(label)}
                    <Inline isRender={isRequired} className="required">*</Inline>
                </label>
            </CRRender>

            <div
                ref={dropZoneRef}
                className={`file-upload-dropzone pointer ${isDragging ? 'dragging' : ''} ${!value?.isEmpty() ? 'has-file' : ''} ${errors?.length && 'uploader-error'}`}
                onDragEnter={handleDragEnter}
                onDragOver={stopDefaultEvent}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => inputRef.current?.click()}
            >
                <input
                    ref={inputRef}
                    type="file"
                    accept={accept}
                    multiple={multiple}
                    onChange={handleInputChange}
                    className="file-upload-input"
                />

                <div className={`file-upload-placeholder`}>
                    <CRIcon icon={"bytesize:upload"} className="upload-icon" />
                    <div className="upload-text">
                        <span className="upload-text-main">{t("drag-drop-files")}</span>
                        <div className='d-flex gap-2 upload-text-sub'>
                            <span className=''>{t('supported-formats')}</span>
                             {supportedTypes}
                        </div>
                        <div className="upload-text-sub">{t("max-file-size")} {maxfilesize} {t("mb")}</div>
                        <div className="upload-text-sub">{t("max-files-allowed")} {maxfiles} {t("files-count")}</div>
                    </div>
                </div>
                <CRRender isRender={errors?.length}>
                    {errors?.map((error) => (
                        <p key={error} className="error-message">{t(error)}</p>
                    ))}
                </CRRender>
            </div>
            <Block isRender={!value?.isEmpty()} className="file-upload-preview-container">
                    {value?.map((item,index) =>
                        <ItemPreviewer key={item?.name} item={item} 
                        handleRemove={handleRemove} getFileIcon={getFileIcon}
                        formatFileSize={formatFileSize} t={t}
                        getFileFormat={getFileFormat}
                        // index={index}
                          />
                    )}
                </Block>
        </div>
    )
}

export default FileUpload

